import { DocumentTextIcon, VolumeUpIcon } from "@heroicons/react/outline";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import FileListView from "./FileListView";
import UploadErrors from "./UploadError";

type AudioDropZoneProps = {
  onUpload: any;
  isUploading: any;
  fileUploaded?: any;
  signedId?: string;
  onDelete?: any;
};

export default function AudioDropZone({
  onUpload,
  isUploading,
  fileUploaded,
  signedId,
  onDelete
}: AudioDropZoneProps) {
  const LocalBasePath = "page.sanadInfo";
  const { t } = useTranslation("", {
    keyPrefix: LocalBasePath,
  });
  const [file, setFile] = useState<any>(null);
  const [uploadedListStatus, setUploadedListStatus] = useState<any>(null);
  const [uploadStatus, setUploadStatus] = useState<any>(0);
  const onDrop = useCallback(async (acceptedFiles) => {
    // Upload Funcation and Api Goes here
    setFile(acceptedFiles[0]);
    onUpload(acceptedFiles[0]);
  }, []);
  useEffect(() => {
    setUploadedListStatus(fileUploaded);

  }, [fileUploaded]);
  const { getRootProps, getInputProps, isDragActive, fileRejections } =
    useDropzone({
      onDrop,
      accept: ["application/pdf", "image/jpeg", "image/png", "image/jpg"],
      maxFiles: 1,
      multiple: false,
      maxSize: 10 * 1024 * 1024, // 10 MegaBytes,

    });
  useEffect(() => {
    setUploadStatus(0);
    if (!!file) {
      // REMOVE THIS WHEN API IS READY TO RESOLVE WARNING
      setTimeout(() => {
        setUploadStatus(100);
      }, 1000);
    }
  }, [file]);

  useEffect(() => {
    isUploading(uploadStatus < 100);
  }, [uploadStatus]);
  const emptyList = () => {
    setFile(null);
    setUploadedListStatus(null);
    onDelete();
  };
  const errorMessages: { [errorCode: string]: string } = {
    "file-too-large": t("errorSizeFile", { size: 10 }),
    "file-invalid-type": t("errorFile"),
  };
  return (
    <div className="col-span-3">
      {!uploadedListStatus && (
        <div
          {...getRootProps({ className: "dropzone" })}
          className="mt-1 border-2 border-gray-300 border-dashed rounded-md px-6 pt-5 pb-6 flex justify-center"
        >
          <input   {...getInputProps()}/>

          <div className="space-y-1 text-center">
            <DocumentTextIcon className="w-12 h-12 mx-auto text-gray-500" />
            <div className=" text-gray-600">
              <div className="flex justify-center">
                <h6 className="text-brandblue-500">{t("browse") + " "}</h6>
                <h6 className="px-1"> {t("dragDrop")}</h6>
              </div>
              <h6>{isDragActive}</h6>
            </div>
            <p className="text-xs text-gray-500">{t("fileRequirements")}</p>
          </div>
        </div>
      )}
      <UploadErrors
        fileRejections={fileRejections}
        errorMessages={errorMessages}
      />
      {!!file && parseInt(uploadStatus) === 100 && (
        <FileListView
          title={file.name}
          signedId={signedId}
          subTitle={file.type}
          fileUploaded={uploadedListStatus}
          color={"bg-brandblue-300"}
          icon={<DocumentTextIcon className="w-10 h-10 mx-auto text-white" />}
          onClose={() => emptyList()}
        />
      )}
      {!!file && uploadStatus < 100 && (
        <>
          <div className="flex justify-between pt-4">
            <h6 className="px-1 truncate w-2/4"> {file?.name!}</h6>
            <h6 className="px-1 	"> {uploadStatus}%</h6>
          </div>
          <div className="relative pt-1">
            <div className="overflow-hidden h-2 mb-4 text-xs flex rounded bg-brandblue-200">
              <div
                style={{ width: `${uploadStatus}%` }}
                className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-brandblue-500"
              ></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
